// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const useStyles = (theme: any) => ({
  listWrapper: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(1),
  },
  checkbox: {
    padding: theme.spacing(0.5),
  },
  deselectButton: {
    color: 'grey',
    display: 'none',
  },
  checkboxWrapper: {
    top: '50%',
    right: '0px',
    position: 'relative',
    transform: 'unset',
  },
  listItem: {
    paddingBottom: '0px',
    paddingTop: '0px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    '& .Mui-selected': {
      backgroundColor: '#eee !important',
    },
  },
  listItemButton: {
    textTransform: 'none',
    padding: '5px',
    width: '350px',
    fontWeight: 300,
    justifyContent: 'left',
    color: '#000',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  projectLayersText: {
    paddingLeft: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  listItemText: {
    fontWeight: 300,
    fontSize: '14px',
    flex: 1,
    overflowY: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  inputField: {
    width: '210px',
    padding: '6px',
    background: 'white',
    height: '14px',
  },
  layerText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  searchInput: {
    margin: '0px 16px',
    '& .MuiInputBase-input': {
      padding: '12px 14px 12px 8px',
      fontSize: '16px',
      color: 'rgba(0, 0, 0, 0.87)',
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.6)',
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-root': {
      paddingLeft: '8px',
      height: '48px',
      borderRadius: '0px',
      borderBottom: '1px solid rgba(0, 0, 0, 0.23)',
      '&:hover': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.54)',
      },
      '&.Mui-focused': {
        borderBottom: '2px solid #2E4DEB',
      },
    },
  },
  visiblealllayers: {
    color: 'primary.main',
    fontWeight: 800,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': { opacity: 0.8 },
  },
  viewalllayerbox: {
    textAlign: 'center',
    py: 1,
  },
  eyetoggleopac: {
    opacity: 0.6,
    padding: '8px 0 0 10px',
  },
  expansionPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
  layerName: {
    color: '#021E40',
  },
  sliderbtn: {
    marginLeft: 'auto',
    marginRight: '8px',
    padding: '4px',
  },
  adjustpannelicon: {
    width: '20px',
    height: '20px',
  },
});

export default useStyles;
